import { React, useState, useEffect, useRef, forwardRef, useImperativeHandle } from 'react';
import { useHistory } from 'react-router-dom';
import styled from 'styled-components';

import CategorySelectBox1 from '../../../Component/SettingComponent/ASPCategorySelectBox';
import CategorySelectBox from '../../../Component/SettingComponent/CategorySelectBox';
import MemberShipAddModal from './Modal/MemberShipAddModal';
import ClassAddModal from './Modal/ClassAddModal';
import MemberShipInfoBox from '../../../Component/SettingComponent/MemberShipInfoBox';
import ClassInfoBox from '../../../Component/SettingComponent/ClassInfoBox';

import FetchModule from '../../Share/Network/FetchModule';
import DeleteConfirmModal from './Modal/DeleteConfirmModal';
import CustomAlert from '../../Share/Normal/CustomAlert';

const MemberShipAndClassView = forwardRef((props, ref) => {
  const { isOver } = props;
  const history = useHistory();

  const [isMemberShipAddClick, setIsMemberShipAddClick] = useState(false);
  const [isClassAddClick, setIsClassAddClick] = useState(false);
  const [isConfirm, setIsConfirm] = useState(false);
  const [isViewCustomAlert, setIsViewCustomAlert] = useState(false);

  const [rendering, setRendering] = useState(false);
  const [categoryRendering, setCategoryRendering] = useState(false);
  const [memberShipData, setMemberShipData] = useState([]);
  const [classData, setClassData] = useState([]);
  const [memberShipSplitData, setMemberShipSplitData] = useState([]);
  const [classSplitData, setClassSplitData] = useState([]);
  const [memberShipClickIndex, setMemberShipClickIndex] = useState(-1);
  const [classClickIndex, setClassClickIndex] = useState(-1);

  const [toBeDeletedDivision, setToBeDeletedDivision] = useState('None');
  const [toBeDeletedData, setToBeDeletedDate] = useState(-1);

  const [coachList, setCoachList] = useState([]);
  const [options, setOptions] = useState([]);

  const [alertText, setAlertText] = useState('');

  const TopLevelRef = useRef();
  const MemberShipCategoryRef = useRef();
  const ClassCategoryRef = useRef();
  const MemberShipAddModalRef = useRef();
  const ClassAddModalRef = useRef();

  useImperativeHandle(ref, () => ({
		setOpacity: (val) => {
			TopLevelRef.current.style.opacity = val;
		},
    setZindex: (val) => {
      TopLevelRef.current.style.zIndex = val;
    }
	}))

  // 페이지 렌더링시 API호출
  useEffect(() => {
    const fetchModule = new FetchModule();
    (
      async () => {
        const responseData = await fetchModule.getData('membership/', 'GET');
        
        if (responseData.status === 200) {
          setMemberShipData(responseData.data);
          setMemberShipSplitData(responseData.data);
        }
        else if (responseData.status === 401) history.push('/');
        else if (responseData.status !== 204) {}
      }
    )();

    (
      async () => {
        const responseData = await fetchModule.getData('lesson/', 'GET');
        
        if (responseData.status === 200) {
          setClassData(responseData.data);
          setClassSplitData(responseData.data);
        }
        else if (responseData.status === 401) history.push('/');
        else if (responseData.status !== 204) {}


        const data = await fetchModule.getData('coach/', 'GET');
        
        if (data.status === 200) setCoachList(data.data);
        else if (data.status === 401) history.push('/');
        else {}
      }
    )();

    ClassCategoryRef.current?.setValue({ id: undefined, name: '전체' });
    MemberShipCategoryRef.current?.setValue({ id: undefined, name: '전체' });
  }, [history, rendering])
  
  // 카테고리 정보 받아오기
  useEffect(() => {
    setOptions([]);
    (
      async () => {
        const fetchModule = new FetchModule();
        const data = await fetchModule.getData('membership/category/', 'GET');
        
        if (data.status === 200) {
					var newData = data.data;
	
					newData.unshift({ name: '전체' });
					setOptions(newData);
				}
        else if (data.status === 204) {
          setOptions([{ id: undefined, name: '전체'}]);
        }
        else if (data.status === 401) history.push('/');
      }
    )();
  }, [history, categoryRendering])

  // Modal이 꺼지면 전달 Index를 재 정리
  useEffect(() => {
    if (!isMemberShipAddClick) setMemberShipClickIndex(-1);
  }, [isMemberShipAddClick])

  // Modal이 꺼지면 전달 Index를 재 정리
  useEffect(() => {
    if (!isClassAddClick) setClassClickIndex(-1);
  }, [isClassAddClick])

  // 카테고리 선택시 회원권 정보를 카테고리에 맞게 정리
  function selectMemberShipValueChange(value) {
    if (value.name === '전체') {
      setClassSplitData(classData);

      return;
    }

    var tmpData = memberShipData.slice();
    var categoryId = value.id;
    var newDataList = [];

    for (var i = 0; i < tmpData.length; i++) {
      if (tmpData[i].categoryId === categoryId) newDataList.push(tmpData[i]);
    }

    setMemberShipSplitData(newDataList);
  }

  // 카테고리 선택시 수업 정보를 카테고리에 맞게 정리
  function selectClassValueChange(value) {

    if (value.name === '전체') {
      setClassSplitData(classData);

      return;
    }

    var tmpData = classData.slice();
    var categoryId = value.id;
    var newDataList = [];

    for (var i = 0; i < tmpData.length; i++) {
      if (tmpData[i].categoryId === categoryId) {
        newDataList.push(tmpData[i]);
      }
    }

    setClassSplitData(newDataList);
  }

  // 회원권 수정 클릭시 Index를 전달
  function memberShipModifyClick(index) {
    setMemberShipClickIndex(index);
    setIsMemberShipAddClick(true);
  }

  // 회원권 삭제 클릭시 API호출
  function memberShipDeleteClick(index) {
    setToBeDeletedDivision('MemberShip');
    setToBeDeletedDate(memberShipSplitData[index]);
    setIsConfirm(true);
  }

  // 회원권 수정 클릭시 Index를 전달
  function classModifyClick(index) {
    setClassClickIndex(index);
    setIsClassAddClick(true);
  }

  // 회원권 삭제 클릭시 API호출
  function classDeleteClick(index) {
    setToBeDeletedDivision('Lesson');
    setToBeDeletedDate(classSplitData[index]);
    setIsConfirm(true);
  }

  // 삭제 확인 버튼 클릭시
  function deleteYesClick() {
    if (toBeDeletedDivision === 'Lesson') {
      const fetchModule = new FetchModule();
      (
        async () => {
          const responseData = await fetchModule.deleteData('lesson/delete/' + toBeDeletedData.id, 'DELETE');
          // console.log(responseData);
          if (responseData.status === 200) setRendering(!rendering);
          else if (responseData.status === 203) {
            setAlertText('아직 수업 일정이 존재합니다.\n해당 수업과 관련된 스케줄을 삭제 후 다시 시도해주세요.');
            setIsViewCustomAlert(true);
          }
          else if (responseData.status === 204) {
            setAlertText('회원권 정보를 삭제하는데 실패하였습니다.\n잠시후 다시시도 해주세요');
            setIsViewCustomAlert(true);
          }
          else if (responseData.status === 401) history.push('/');
        }
      )();
    }
    else if (toBeDeletedDivision === 'MemberShip') {
      const fetchModule = new FetchModule();
      (
        async () => {
          const responseData = await fetchModule.deleteData('membership/delete/' + toBeDeletedData.id, 'DELETE');

          if (responseData.status === 200) setRendering(!rendering);
          else if (responseData.status === 203) {
            setAlertText('아직 만료되지 않은 회원권이 존재합니다.\n진행중인 회원권을 삭제 후 다시시도해 주세요.');
            setIsViewCustomAlert(true);
          }
          else if (responseData.status === 204) {
            setAlertText("회원권 정보를 삭제하는데 실패하였습니다.\n잠시후 다시시도 해주세요");
            setIsViewCustomAlert(true);
          }
          else if (responseData.status === 401) history.push('/');
        }
      )();
    }
    setIsConfirm(false);
  }

  // 삭제 취소 클릭시
  function deleteButtonClick() {
    setToBeDeletedDivision('None');
    setToBeDeletedDate(undefined);
    setIsConfirm(false);
  }

  // Modal 취소 버튼 클릭시
  function exitClickFn(className) {
    if (className === 'MemberShip') setIsMemberShipAddClick(false);
    else if (className === 'Class') setIsClassAddClick(false);
  }

  function selectClickFn(className) {
    if (className === 'class') MemberShipCategoryRef.current.setIsClicked();
    else ClassCategoryRef.current.setIsClicked();
  }

  return (
    <TopLevelWrapper ref={TopLevelRef}>
      { isViewCustomAlert && <CustomAlert isOver={isOver} text={alertText} closeFn={() => setIsViewCustomAlert(false)}/> }
      { isMemberShipAddClick && <MemberShipAddModal ref={MemberShipAddModalRef} isOver={isOver} data={memberShipSplitData} index={memberShipClickIndex} rendering={() => setRendering(!rendering)} exitClickFn={exitClickFn} /> }
      { isClassAddClick && <ClassAddModal ref={ClassAddModalRef} isOver={isOver} data={classSplitData} index={classClickIndex} rendering={() => setRendering(!rendering)} exitClickFn={exitClickFn} />  }
      { isConfirm && <DeleteConfirmModal isOver={isOver} title={toBeDeletedDivision === 'Lesson' ? '수업 삭제' : '회원권 삭제'} itemName={toBeDeletedData.name + (toBeDeletedDivision === 'Lesson' ? ' 수업' : ' 회원권')} clickNoFn={deleteButtonClick} clickYesFn={deleteYesClick}/>}
      <InfoBox isOver={isOver}>
        <ModelWrapper>
          <Title>수업</Title>
          <ComponentWrapper isOver={isOver}>
            <Text>카테고리</Text>
            <CategorySelectBox ref={ClassCategoryRef} isOver={isOver} options={options} width={isOver ? `max(634px, 82.55208333333333vw)` : `max(240px, 75vw)`} rendering={categoryRendering} setRendering={setCategoryRendering} changeVal={selectClassValueChange} isModal={false} selectClickFn={() => selectClickFn('class')}/>
          </ComponentWrapper>
          <ComponentWrapper isOver={isOver}>
            <Text>수업</Text>
            <InfoWrapper isOver={isOver}>
              {
                classSplitData.map((data, index) => 
                (
                  <ClassInfoBox 
                    key={index}  
                    isOver={isOver}
                    data={data} 
                    index={index} 
                    coachList={coachList}
                    modifyClickFn={classModifyClick}
                    deleteClickFn={classDeleteClick}/>
                ))
              }
            </InfoWrapper>
          </ComponentWrapper>
          <ButtonWrapper isOver={isOver}>
            <ClassAddButton isOver={isOver} onClick={() => setIsClassAddClick(true)}>수업 추가</ClassAddButton>
          </ButtonWrapper>
        </ModelWrapper>
      </InfoBox>
      <InfoBox isOver={isOver}>
        <ModelWrapper>
          <Title>회원권</Title>
          <ComponentWrapper isOver={isOver}>
            <Text>카테고리</Text>
            <CategorySelectBox ref={MemberShipCategoryRef} isOver={isOver} options={options} width={isOver ? `max(634px, 82.55208333333333vw)` : `max(240px, 75vw)`} rendering={categoryRendering} setRendering={setCategoryRendering} changeVal={selectMemberShipValueChange} isModal={false} selectClickFn={() => selectClickFn('membership')}/>
          </ComponentWrapper>
          <ComponentWrapper isOver={isOver}>
            <Text>회원권</Text>
            <InfoWrapper isOver={isOver}>
              {
                memberShipSplitData.map((data, index) =>
                (
                  <MemberShipInfoBox
                    key={index}
                    isOver={isOver}
                    data={data}
                    index={index}
                    modifyClickFn={memberShipModifyClick}
                    deleteClickFn={memberShipDeleteClick} />)
                )
              }
            </InfoWrapper>
          </ComponentWrapper>
          <ButtonWrapper isOver={isOver}>
            <MemberShipAddButton isOver={isOver} onClick={() => setIsMemberShipAddClick(true)}>회원권 추가</MemberShipAddButton>
          </ButtonWrapper>
        </ModelWrapper>
      </InfoBox>
    </TopLevelWrapper>
  )
})

export default MemberShipAndClassView;

const TopLevelWrapper = styled.div`
  display: flex;
  // flex-direction: row;
  flex-direction: column;

  // justify-content: center;
  // align-items: center;

  gap: 30px;

  margin-top: 17px;
  margin-bottom: 96px;
  
  transition: all 0.3s ease-in-out;
`;

const InfoBox = styled.div`
  display: flex;
  flex-direction: column;

  justify-content: center;
  align-items: center;
  
  // width: ${props => props.width}px;
  width: ${props => props.isOver ? `max(692px, 90.10416666666667vw)` : `max(296px, 92.5vw)`};
  height: 590px;

  border-radius: 30px;
  box-shadow: 0px 40px 50px rgba(240, 232, 227, 0.5);
  background-color: #FFFFFF;
`;

const ModelWrapper = styled.div`
  display: flex;
  flex-direction: column;

  justify-content: center;
`;

const Title = styled.p`
  font-family: NotoSansKR-Medium;
  font-size: 14px;

  color: #232323;

  margin: 0 0 0 0;
`;

const ComponentWrapper = styled.div`
  display: flex;
  flex-direction: column;

  justify-content: center;
  align-items: flex-start;

  margin-top: ${props => props.isOver ? `24px` : `26px`};
`;

const InfoWrapper = styled.div`
  display: flex;
  flex-direction: column;

  // justify-content: center;
  align-items: flex-start;

  // width: 462px;
  width: ${props => props.isOver ? `max(644px, 83.85416666666667vw)` : `max(244px, 76.25vw)`};
  height: 300px;

  padding: 0 0 0 0;
  
  overflow-y: scroll;
  overflow-x: none;

	&::-webkit-scrollbar {
		width: 2px;
	}

	&::-webkit-scrollbar-thumb {
    box-shadow: inset 0 0 10px 20px #DFDFDF;
		border: 3px solid transparent;
		height: 25px;
		// background-color: #FF8B48;
		border-radius: 200px;
	}

	&::-webkit-scrollbar-track {
    box-shadow: inset 0 0 10px 10px transparent;
		border: 4px solid transparent;
		background-color: transparent;
	}

	&::-webkit-scrollbar-track-piece {
		background-color: transparent;
	}
`;

const Text = styled.p`
  font-family: NotoSansKR-Regular;
  font-size: 12px;

  color: #595959;

  margin: 0 0 0 0;
`;

const ButtonWrapper = styled.div`
  display: flex;
  flex-direction: row;

  justify-content: flex-end;
  align-items: flex-start;

  width: ${props => props.isOver ? `max(636px, 82.8125vw)` : `max(240px, 75vw)`};
`;

const MemberShipAddButton = styled.div`
  display: flex;
  flex-direction: row;

  justify-content: center;
  align-items: center;

  width: ${props => props.isOver ? `114px` : `87px`};
  height: ${props => props.isOver ? `38px` : `29px`};

  border: 1px solid #DFDFDF;
  border-radius: ${props => props.isOver ? `15px` : `9px`};

  font-family: NotoSansKR-Medium;
  font-size: ${props => props.isOver ? `14px` : `12px`};

  color: #CBCBCB;

  // margin: 46px 0 0 338px;
  margin: ${props => props.isOver ? `16px 0 0 548px` : `16px 0 0 150px`};

  :hover {
    cursor: pointer;
  }
`;

const ClassAddButton = styled.div`
  display: flex;
  flex-direction: row;

  justify-content: center;
  align-items: center;

  width: ${props => props.isOver ? `101px` : `87px`};
  height: ${props => props.isOver ? `38px` : `29px`};

  border: 1px solid #DFDFDF;
  border-radius: ${props => props.isOver ? `15px` : `9px`};

  font-family: NotoSansKR-Medium;
  font-size: ${props => props.isOver ? `14px` : `12px`};

  color: #CBCBCB;

  // margin: 46px 0 0 321px;
  // margin: 36px 0 0 548px;
  margin: ${props => props.isOver ? `16px 0 0 548px` : `16px 0 0 150px`};

  :hover {
    cursor: pointer;
  }
`;